import React from 'react';
import classNames from 'classnames/bind';
import { withAutoMetric } from '@beef/auto-metric';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var _GridItem = function _GridItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    grow = _ref.grow;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('item', className, grow && 'grow'),
    "data-t-id": "components-AutoGrid"
  }, children);
};
export var GridItem = withAutoMetric.Item()(_GridItem);